import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import RoutingContext from '../../../../context/RoutingContext'
import RootLayout from './RootLayout/RootLayout'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const RootLayoutModule = ({ children }) => {
  const { appRouting } = useContext(RoutingContext)

  return <RootLayout logoutPath={appRouting.logoutPath}>{children}</RootLayout>
}

RootLayoutModule.propTypes = { children: PropTypes.node }

RootLayoutModule.defaultProps = { children: undefined }

export default RootLayoutModule
